<template>
    <app-layout>
        <router-view></router-view>
    </app-layout>
</template>

<script>
import AppLayout from '../../components/layout/app-layout';

export default {
    name: 'Index',

    components: { AppLayout }
};
</script>

<style lang="scss" scoped></style>
